import React, { useEffect, useState, useContext, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BookMark, { BookMarkItemData } from "../../components/SatCourse/BookMark";
// @ts-ignore
import { getBookmarkedTopics, bookmarkTopic, deleteBookmarkTopic } from "../../services/SatCourseService";
// @ts-ignore
import ApiNames from "../../constants/ApiNames";
// @ts-ignore
import UserContext from "../../utils/UserContext";

export interface BookMarkScreenProps {
  token?: string;
  moduleIndex?: number;
  loaderStatus: (status: boolean) => void;
}

const BookMarkScreen: React.FC<BookMarkScreenProps> = (props) => {
  const { subscriberId, checkRefresh, setActiveIndex, activeIndex } = useContext<any>(UserContext);
  const useLocations = useLocation();
  const title = useLocations.state?.title || "";
  const moduleIndex = useLocations.state?.index || 0;
  
  const [isError, setError] = useState<string>("");
  const [bookMarkData, setBookMarkData] = useState<BookMarkItemData[]>([]);
  const navigate = useNavigate();

  const BookMarkapiCall = useCallback(async () => {
    try {
      props.loaderStatus(false);
      const response = await getBookmarkedTopics(subscriberId, props.token);

      if (response && response.status === 200) {
        setBookMarkData(response.response || []);
        props.loaderStatus(true);
      } else {
        setError("Error loading bookmarks");
        props.loaderStatus(false);
        console.log("Response", response?.status);
      }
    } catch (error: any) {
      console.log(error);
      setError(error.message || "Error");
      props.loaderStatus(true);
    }
  }, [props, subscriberId]);

  useEffect(() => {
    BookMarkapiCall();
    if (!checkRefresh) {
      setActiveIndex(moduleIndex);
    } else if (activeIndex !== props?.moduleIndex) {
      setActiveIndex(moduleIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const HandleBookMark = useCallback(async (id: string | number, index: number) => {
    const data = {
      subscriberId: subscriberId,
      topicId: id,
    };
    try {
      const response = await bookmarkTopic(data, props.token);
      if (response && response.status === 200) {
        const newData = [...bookMarkData];
        newData[index].isBookmarked = !newData[index].isBookmarked;
        setBookMarkData(newData);
      } else {
        console.log("Response", response?.status);
      }
    } catch (error) {
      console.log("FAIL to load");
    }
  }, [bookMarkData, props.token, subscriberId]);

  const HandleDeleteBookMark = useCallback(async (id: string | number, index: number) => {
    const data = {
      subscriberId: subscriberId,
      topicId: id,
    };
    try {
      const response = await deleteBookmarkTopic(data, props.token);

      if (response && response.status === 200) {
        const filteredArray = bookMarkData.filter((item, e) => e !== index);
        setBookMarkData(filteredArray);
      } else {
        console.log("Response", response?.status);
      }
    } catch (error) {
      console.log("FAIL");
    }
  }, [bookMarkData, props.token, subscriberId]);

  const HandleBookMarkVideo = useCallback((item: BookMarkItemData) => {
    const listData = [item];
    navigate("/content", {
      state: {
        listData: listData,
        checkBookMarkScreen: true,
        index: 0,
        chapterTitle: item.chapterName,
        moduleIndexbookMark: moduleIndex,
      },
    });
  }, [navigate, moduleIndex]);

  const HandleArrow = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <BookMark
      bookMarkData={bookMarkData}
      isError={isError}
      title={title}
      HandleBookMark={HandleBookMark}
      HandleDeleteBookMark={HandleDeleteBookMark}
      HandleBookMarkVideo={HandleBookMarkVideo}
      HandleArrow={HandleArrow}
    />
  );
};

export default BookMarkScreen;
